"use client";

interface PlanAndPriceItem {
    plan: string;
    name: string;
    price1: string;
    price2: string;
    detailList: string[];
    popular: boolean;
    ismobile: boolean;
}

const PlanAndPriceItem = ({ item }: { item: PlanAndPriceItem }) => {
    const TitleTag = item.ismobile ? "span" : "h3";

    return (
        <div className={"item".concat(` ${item.plan}`)}>
            {item.popular ? <div className="popular">Most Popular</div> : ""}
            {/* Include additional div component for popular */}
            {item.popular ? (
                <div className={item.plan}>
                    <div>
                        <TitleTag className="plan">{item.name}</TitleTag>
                        <div className="price text-medium">
                            <span className="text-largexlarge">
                                {item.price1}
                            </span>
                            {` ${item.price2}`}
                        </div>
                    </div>
                    <div className="text-medium">
                        {item.detailList.map((item, index) => (
                            <div key={index}>&rarr; {item}</div>
                        ))}
                    </div>
                </div>
            ) : (
                <>
                    <div>
                        <TitleTag className="plan">{item.name}</TitleTag>
                        <div className="price text-medium">
                            <span className="text-largexlarge">
                                {item.price1}
                            </span>
                            {` ${item.price2}`}
                        </div>
                    </div>
                    <div className="text-medium">
                        {item.detailList.map((item, index) => (
                            <div key={index}>&rarr; {item}</div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default PlanAndPriceItem;
